import Model from '@/models/Model'

export default class HrPrevision extends Model {
    resource() {
        return 'hr_prevision'
    }
}